import { render } from "./PantryUsedUpCheckTagItem.vue?vue&type=template&id=5ecee48e&scoped=true&ts=true"
import script from "./PantryUsedUpCheckTagItem.vue?vue&type=script&lang=ts"
export * from "./PantryUsedUpCheckTagItem.vue?vue&type=script&lang=ts"

import "./PantryUsedUpCheckTagItem.vue?vue&type=style&index=0&id=5ecee48e&lang=scss&scoped=true"

import exportComponent from "/home/smith/kitchenwebapp/kitchenwebapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ecee48e"]])

export default __exports__